import { INhapKhoImportRequest } from "../../../model/request/category/INhapKhoImportRequest"
import { INhapKhoDelete } from "../../../model/request/category/INhapKhoDelete"
import { INhapKho, INhapKhoViewModel } from "../../../model/respone/category/INhapKho"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eNhapKhoActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as INhapKhoViewModel[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | INhapKho,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as INhapKho,
    SAVE_SUCCESS: {} as INhapKho,
    SAVE_ERROR: "",

    DELETE_START: {} as INhapKhoDelete,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_IMPORT_MODAL: undefined,
    CLOSE_IMPORT_MODAL: undefined,

    SAVE_IMPORT_START: {} as INhapKhoImportRequest,
    SAVE_IMPORT_SUCCESS: {} as INhapKho[],
    SAVE_IMPORT_ERROR: "",
}
export const eNhapKhoActionTypeIds = generateActionTypeIds(eNhapKhoActionTypeDefine, "NHAP_KHO")

export type INhapKhoActions = IGenericActionType<typeof eNhapKhoActionTypeDefine, "NHAP_KHO">